import { get } from 'lodash';
import { extractTextStyles } from '../../utils/elements';
import { IconSize, IconSpacing } from './types';
export function resolveInnerPadding(data) {
    const size = get(data, 'styles.size');
    const spacingMap = {
        small: IconSpacing.small,
        medium: IconSpacing.medium,
        large: IconSpacing.large,
    };
    const value = parseInt((size && spacingMap[size]) || IconSpacing.medium, 10);
    return `0 ${value / 2}px`;
}
export function resolveIconSize(data) {
    const size = get(data, 'styles.size');
    const sizeMap = {
        small: IconSize.small,
        medium: IconSize.medium,
        large: IconSize.large,
    };
    return (size && sizeMap[size]) || IconSize.medium;
}
export function resolveTitle(css, data) {
    const titleClassName = 'so-global-h3';
    const defaultTitleStyle = get(css, titleClassName, {});
    const customTitleStyle = get(data, 'styles', {});
    const extractedTextStyles = extractTextStyles(customTitleStyle, defaultTitleStyle);
    const title = data.label
        ? {
            text: data.label,
            ...extractedTextStyles,
        }
        : null;
    return title;
}
//# sourceMappingURL=utils.js.map